import apiClient from './client';
import type { Url, CreateUrlInput, UpdateUrlInput } from '@/types/url';

// ========== URLS API ==========

// Listar todas as URLs
export const getUrls = async (): Promise<Url[]> => {
    const response = await apiClient.get<Url[]>('/urls');
    return response.data;
};

// Obter URL por ID
export const getUrlById = async (urlId: number): Promise<Url> => {
    const response = await apiClient.get<Url>(`/urls/${urlId}`);
    return response.data;
};

// Criar nova URL
export const createUrl = async (data: CreateUrlInput): Promise<Url> => {
    const response = await apiClient.post<Url>('/urls', data);
    return response.data;
};

// Atualizar URL
export const updateUrl = async (urlId: number, data: UpdateUrlInput): Promise<Url> => {
    const response = await apiClient.put<Url>(`/urls/${urlId}`, data);
    return response.data;
};

// Deletar URL
export const deleteUrl = async (urlId: number): Promise<{ message: string; success: boolean }> => {
    const response = await apiClient.delete<{ message: string; success: boolean }>(`/urls/${urlId}`);
    return response.data;
};

